var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTempFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 13V5C14.9998 3.34 13.6598 2 11.9998 2C10.3398 2 8.99976 3.34 8.99976 5V13C7.78976 13.91 6.99976 15.37 6.99976 17C6.99976 19.76 9.23976 22 11.9998 22C14.7598 22 16.9998 19.76 16.9998 17C16.9998 15.37 16.2098 13.91 14.9998 13ZM10.9998 11V5C10.9998 4.45 11.4498 4 11.9998 4C12.5498 4 12.9998 4.45 12.9998 5V6H11.9998V7H12.9998V8V9H11.9998V10H12.9998V11H10.9998Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTempFill);
export default __webpack_public_path__ + "static/media/icon-temp-fill.3ef2c1f6daef78f1fd795b30d1a2bae0.svg";
export { ForwardRef as ReactComponent };